import HttpClientToken from '../../services/HttpClientToken';

import { TipoUsuarioProps, defaultTipoUsuario } from '../../interfaces/catalogos/TipoUsuarioInterface';

export const TipoUsuarios = () => {

    return new Promise<TipoUsuarioProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoUsuario/', token)
            .then( ({ data } : { data : TipoUsuarioProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoUsuarios = () => {

    return new Promise<TipoUsuarioProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoUsuario/ObtenerTipoUsuarios', token)
            .then( ({ data } : { data : TipoUsuarioProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoUsuario = ( params: TipoUsuarioProps ) => {

    return new Promise<TipoUsuarioProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoUsuario/Actualizar', params, token)
            .then( ({ data } : { data : TipoUsuarioProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoUsuario } );
            });

        }

    });

}

export const AgregarTipoUsuario = ( params: TipoUsuarioProps ) => {

    return new Promise<TipoUsuarioProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoUsuario/Agregar', params, token)
            .then( ({ data } : { data : TipoUsuarioProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoUsuario } );
            });

        }

    });

}
